module.exports = __webpack_public_path__ + "img/mitsuicon.407b3294.png";